export default __webpack_public_path__ + "static/fj-f3d86add9fe9ed6722749f8a0f21fc1d.svg";